import { Box, Card, Heading, Text } from '@chakra-ui/react'
import React from 'react'
import { Link } from 'react-router'

import { useExtensionsI18n } from '../i18n/provider'
import { TYPE_SLUG_TO_VIEW_MODE } from '../utils/extensions'
import { getListLabelForSlug, getTypeLabelForSlug } from './typeSlugLabels'

export interface ExtensionEditPlaceholderPageProps {
  type: string
  listRoute: string
  wrapper?: React.ComponentType<{ children: React.ReactNode }>
}

export const ExtensionEditPlaceholderPage: React.FC<
  ExtensionEditPlaceholderPageProps
> = ({ type, listRoute, wrapper: Wrapper }) => {
  const { text } = useExtensionsI18n()
  const typeLabel = getTypeLabelForSlug(type, text)
  const listLabel = getListLabelForSlug(type, text)
  const viewMode = TYPE_SLUG_TO_VIEW_MODE[type]
  const backLink = viewMode ? `${listRoute}?view=${viewMode}` : listRoute

  const content = (
    <Card.Root>
      <Card.Header p={6} pb={2}>
        <Heading size="lg">{typeLabel}</Heading>
      </Card.Header>
      <Card.Body p={6} pt={2}>
        <Box textAlign="center" py={8}>
          <Text color="fg.muted" mb={4}>
            {text(
              'extensions.placeholder.notImplemented',
              'The {{typeLabel}} edit page is not yet implemented.',
              { typeLabel: typeLabel.toLowerCase() },
            )}
          </Text>
          <Link
            to={backLink}
            style={{
              color: 'var(--chakra-colors-blue-500)',
              textDecoration: 'none',
            }}
          >
            {text(
              'extensions.placeholder.backToList',
              'Back to {{listLabel}}',
              {
                listLabel,
              },
            )}
          </Link>
        </Box>
      </Card.Body>
    </Card.Root>
  )

  if (Wrapper) {
    return <Wrapper>{content}</Wrapper>
  }
  return content
}
